import {
  FETCHING_LOGS,
  FETCHING_LOGS_FAILED,
  FETCHING_LOGS_SUCCEEDED,
  FETCHING_METRICS,
  FETCHING_METRICS_SUCCEEDED,
  FETCHING_METRICS_FAILED,
  FETCHING_USER_METRICS,
  FETCHING_USER_METRICS_SUCCEEDED,
  FETCHING_USER_METRICS_FAILED
} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const AUDIT_BASE_URL = `${API_URL}/api/1.0/logs`;

/** fetch logs */
export const fetchLogs = createAction(FETCHING_LOGS);
const fetchingLogsSucceeded = createAction(FETCHING_LOGS_SUCCEEDED);
const fetchingLogsFailed = createAction(FETCHING_LOGS_FAILED);

function* fetchLogsSaga(action) {
  let { page, limit, filterRequest } = action.payload;

  let url = buildUrl(AUDIT_BASE_URL, {
    queryParams: { page: page, limit: limit },
  });
  const fetchLogsAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: filterRequest,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLogsAPI);
    yield put(fetchingLogsSucceeded(response));
  } catch (error) {
    console.log(error)
    yield put(fetchingLogsFailed(error));
  }
}

/** fetch metrics */
export const fetchMetrics = createAction(FETCHING_METRICS);
const fetchingMetricsSucceeded = createAction(FETCHING_METRICS_SUCCEEDED);
const fetchingMetricsFailed = createAction(FETCHING_METRICS_FAILED);

function* fetchMetricsSaga(action) {
  let { filterRequest } = action.payload;

  let url = buildUrl(AUDIT_BASE_URL, {path: "/metrics"});
  const fetchMetricsAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: filterRequest,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchMetricsAPI);
    yield put(fetchingMetricsSucceeded(response));
  } catch (error) {
    yield put(fetchingMetricsFailed(error));
  }
}

/** fetch user metrics */
export const fetchUserMetrics = createAction(FETCHING_USER_METRICS);
const fetchingUserMetricsSucceeded = createAction(FETCHING_USER_METRICS_SUCCEEDED);
const fetchingUserMetricsFailed = createAction(FETCHING_USER_METRICS_FAILED);

function* fetchUserMetricsSaga(action) {
  let { filterRequest } = action.payload;

  let url = buildUrl(AUDIT_BASE_URL, {path: "/metrics/users"});
  const fetchUserMetricsAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: filterRequest,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchUserMetricsAPI);
    yield put(fetchingUserMetricsSucceeded(response));
  } catch (error) {
    yield put(fetchingUserMetricsFailed(error));
  }
}

export default function* auditLogsSaga() {
  yield takeLatest(FETCHING_LOGS, fetchLogsSaga);
  yield takeLatest(FETCHING_METRICS, fetchMetricsSaga);
  yield takeLatest(FETCHING_USER_METRICS, fetchUserMetricsSaga);

}
